import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=66eca0a8&scoped=true&"
import script from "./pay-success.js?vue&type=script&lang=js&"
export * from "./pay-success.js?vue&type=script&lang=js&"
import style0 from "./pay-success.scss?vue&type=style&index=0&id=66eca0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eca0a8",
  null
  
)

export default component.exports